module.exports = __webpack_public_path__ + "static/img/logo_xiangyun.5ae69fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_xiangyun.png
// module id = GKqD
// module chunks = 1